import React from 'react';
import './Quotes.css';

function Quotes() {
  return (
    <div className="quotes">
      <blockquote>
        Doing a mathematical calculation in your head, not trustiing your
        answer, so you ended up using a calculator.
        <br />
        <cite>&quot;Anonymous&quot;</cite>
      </blockquote>
    </div>
  );
}

export default Quotes;
